export default __webpack_public_path__ + "static/media/goshen27.e507e6d8.jpg";